<div class="body-wrapper rtl" *ngIf="loaded" style='padding-top: 0;max-width: 1500px;'>
    <header class="header">
        <div class="justify-between items-center" [innerHtml]="altHeader" *ngIf="altHeader && showHeader" style="width: 100%;"></div>
        <div class="justify-between items-center" *ngIf="cf.env && cf.env['haslogo'] && false">
            <img [src]="! cf.env['haslogo'] ? '../../assets/images/logo.png' : '/api/logo'" alt="Logo">
        </div>
        <div class="justify-between items-center" style="margin-bottom: 5px;">
            <h1 class="header-title">{{'exam.type.followup' | translate}}</h1>
            <img [src]="! cf.env['haslogo'] ? '../../assets/images/logo.png' : '/api/logo'" alt="Logo" class="header-logo" *ngIf="cf.env && ! altHeader && cf.env['haslogo']">
        </div>
        <div class="header-details">
            <div style="display: inline-block; padding-left: 1em;padding-right: 1em">{{'general.date' | translate}}:&nbsp;<strong style='direction: ltr;'>{{cf.selcForm.CreationTime | date:"dd.MM.yyyy HH:mm"}}</strong></div>
            <div style="display: inline-block">{{'general.Printing_Date' | translate}}:&nbsp;<strong style='direction: ltr;'>{{now| date:"dd.MM.yyyy HH:mm"}}</strong></div>
        </div>
    </header>
    <main class="main">
        <section class="section" *ngIf="cf.Pat">
            <h4 class="text-20 text-gold">{{'general.Patient.Patient_Details' | translate}}</h4>
            <div style="width:100%;">
                <div style="width: 100%;">
                    <div style="display: inline-flex;">
                        <table>
                            <tr>
                                <td>
                                    <dt>{{'general.Patient.first_name' | translate}}</dt>
                                    <dd>{{cf.Pat.First}}</dd>
                                </td>
                                <td>
                                    <dt>{{'general.Patient.last_name' | translate}}</dt>
                                    <dd>{{cf.Pat.Last}}</dd>
                                </td>
                                <td>
                                    <dt>{{'general.Patient.ID' | translate}}</dt>
                                    <dd>{{cf.Pat.ID}}</dd>
                                </td>
                                <td *ngIf="cf.Pat.Birth">
                                    <dt>{{'general.Patient.birth_date' | translate}}</dt>
                                    <dd>{{cf.Pat.Birth| date:"dd.MM.yyyy"}}</dd>
                                </td>
                                <td *ngIf="cf.Pat.Birth">
                                    <dt>{{'general.Patient.Age' | translate}}</dt>
                                    <dd>{{cf.Pat.getAgeMo()}}</dd>
                                </td>
                                <td *ngIf="cf.Pat.Mobile">
                                    <dt>{{'general.Patient.mobile' | translate}}</dt>
                                    <dd>{{cf.Pat.Mobile}}</dd>
                                </td>
                                <td *ngIf="cf.Pat.Address">
                                    <dt>{{'general.Patient.address' | translate}}</dt>
                                    <dd>{{cf.Pat.Address}}</dd>
                                </td>
                            </tr>
                            <tr *ngIf="cf.LMP">
                                <td *ngIf="cf.LMP">
                                    <dt>{{'pregnancy.Last_Menstrual_Period.LMP' | translate}}</dt>
                                    <dd>{{cf.LMP|date:"dd.MM.yyyy"}}</dd>
                                </td>
                                <td>
                                    <dt>{{'pregnancy.Last_Menstrual_Period.EDD' | translate}}</dt>
                                    <dd>{{cf.edd(false, cf.LMP)}}</dd>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </section>
        <section *ngIf="cf.selcForm" style="margin-block-start: 20px;">
            <table class="t-calendar formatted" *ngFor="let tri of cf.triArray;index as i" style="border-collapse: collapse;border-spacing: 0 10px;margin-top: -10px;margin-bottom: 30px;break-inside: avoid-page;">
                <tr class="formatted-title">{{'general.tri.'+tri.trianame | translate}}</tr>
                <tr class="t-tr-calendar">
                    <td class="t-td-calendar" style="width: 5%;text-align: center;font-weight: 700;">חודש</td>
                    <td class="t-td-calendar" style="width: 20%;text-align: center;font-weight: 700;">שבוע</td>
                    <td class="t-td-calendar" style="width: 30%;text-align: center;font-weight: 700;">סוג בדיקה</td>
                    <td class="t-td-calendar" style="width: 40%;text-align: center;font-weight: 700;">הערות</td>

                </tr>
                <tr *ngFor="let month of tri.months;index as j" style="text-align-last: center; border-bottom: 1px solid grey; border-radius: 5px;">
                    <td style="width: 5%;">{{month.name}}</td>
                    <td style="width: 95%;padding-left: 0;">
                        <table class="w100" style="border-collapse: collapse;">
                            <tr class="t-tr-calendar" style="text-align: center;" *ngFor="let _ of [].constructor(month.weeks);index as i">
                                <!-- <td class="t-td-calendar" style="width: 10%;">{{i+1}}</td> -->
                                <td style="width: 90%;padding-left: 0;">
                                    <table class="w100 table-calendar">
                                        <tr style="border-bottom: 1px solid grey;">
                                            <td class="t-td-calendar" style="width: 30%;display: inline-flex;justify-content: space-around;">
                                                <span>{{cf.getWeek(month.name, i, tri.trianame)}}</span>
                                                <span>{{(cf.LMP ? 'general.startFrom': '') | translate}}{{cf.getDateByWeek(cf.getWeek(month.name, i, tri.trianame), cf.LMP) |  date:"dd/MM/yyyy"}}</span>
                                            </td>
                                            <td class="t-td-calendar" style="width: 30%;">
                                                <span *ngIf="cf.selcForm['week'+cf.getWeek(month.name, i, tri.trianame)]">
                                                    {{(OB.includes(cf.selcForm['week'+cf.getWeek(month.name, i, tri.trianame)]) ? ('exam.type.OBS.'+cf.selcForm['week'+cf.getWeek(month.name, i, tri.trianame)]) : cf.selcForm['week'+cf.getWeek(month.name, i, tri.trianame)]) | translate}}
                                                    <!-- {{'exam.type.OBS.'+cf.selcForm['week'+cf.getWeek(month.name, i, tri.trianame)] | translate}} -->
                                                </span>
                                            </td>
                                            <td class="t-td-calendar" style="width: 40%;">
                                                <span *ngIf="cf.selcForm['week'+cf.getWeek(month.name, i, tri.trianame)+'Comment']">
                                                    {{cf.selcForm['week'+cf.getWeek(month.name, i, tri.trianame)+'Comment']}}
                                                </span>
                                            </td>
                                        </tr>
                                    </table>
            
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
                <tr>
                    <section class="section" *ngIf="cf.selcForm[tri.trianame+'Tri']">
                        <span class="comment"><strong>{{'general.Comments' | translate}}: </strong>{{cf.selcForm[tri.trianame+'Tri']}}</span>
                    </section>
                </tr>
            </table>
            <section class="section" *ngIf="cf.selcForm && cf.selcForm.plannerComment">
                <span class="comment"><strong>{{'general.Comments' | translate}}: </strong>{{cf.selcForm.plannerComment}}</span>
                
            </section>

        </section>
        <section class="section">
            <table>
                <tr *ngFor="let signer of cf.signers;let i = index">
                <td class="w-1/3"><strong>{{(signer['Title'] ?  signer['Title']+ ' ': '')+ signer.Name}}</strong></td>
                <td class="w-1/3">
                    <ng-container *ngIf="signer.DrNum">מ.ר. <strong>{{signer.DrNum}} </strong></ng-container>
                    <ng-container *ngIf="signer.ExpertNum">מ.ר.מ. <strong>{{signer.ExpertNum}}</strong></ng-container>
                </td>
                <td class="w-1/3" *ngIf="i == 0">{{'general.date' | translate}}: <strong>{{cf.selcForm.CreationTime | date:"dd.MM.yyyy"}}</strong></td>
                </tr>
            </table>
        </section>
		<span class="finished" *ngIf="loaded"></span>

    </main>
</div>